class applyDiscount extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-code-input]');
      this.submitBtn = this.querySelector('[data-apply-coupon-trigger]');
      this.staticCodes = this.querySelectorAll('[data-coupon-code]');
      this.errorEle = this.querySelector('.notification-wrapper');
      this.model = this.closest('modal-dialog');
    }
    connectedCallback() {
      this.submitBtn?.addEventListener('click', this.handleSubmit.bind(this));
      this.staticCodes?.forEach(ele => {
        ele.addEventListener('click', (e) => {
          e.preventDefault();
          this.input.value = e.currentTarget.dataset.couponCode;
          this.submitBtn.click();
          this.submitBtn.dispatchEvent(new Event('click'));
        })
      });
    }
    handleSubmit(e) {
      e.preventDefault();
      if (this.input.value != '') {
        this.submitBtn.classList.add('loading');
        fetch(`/discount/${this.input.value}`)
        .then((response) => {
          console.log('response');
          console.log(response);
          if (response.ok) {
            return response.text(); // If the response is OK, parse it as JSON
          }
          throw new Error('Failed to apply discount');
        })
        .then(data => {
           fetch('/cart.js')
        .then(cartRes => cartRes.json())
        .then(cartData => {
          // Check if discount is applied
          if (cartData.cart_level_discount_applications.length > 0) {
            this.errorEle.innerHTML = '<span class="text-success"  style="color:green;">Code applied! Discount will apply at Checkout Page.</span>';
          setTimeout(() => {
            this.errorEle.innerHTML = '';  
          }, 5500);
          
          setTimeout(() => {
            if(__st.p === 'cart') {
              location.reload(); 
            }
          }, 500);
          } else {
            this.submitBtn.classList.remove('loading');
            this.errorEle.innerHTML = `<span class="text-danger" style="color:red; margin-left:10px;">Invalid discount code. Please try again.</span>`;
          setTimeout(() => {
            this.errorEle.innerHTML = '';  
          }, 5500);
          }
        })
        });
      } else {
        this.errorEle.innerHTML = '<span class="text-danger" style="color:red; margin-left:10px;">Please enter code</span>';
        setTimeout(() => {
          this.errorEle.innerHTML = '';  
        }, 5500);
      }
    }
  }
  customElements.define('apply-discount', applyDiscount);